global.$ = global.jQuery = require('jquery');
require('foundation-sites');
// require('owl.carousel');
// require('foundation-datepicker')
require('magnific-popup');

$(document).ready(function(){

    $("button.hamburger").on('click',function(e) {
        $(".title-bar").toggleClass("opened");
        $("#stickyContactMobil").toggleClass("disapear");
    })

    $('[data-drilldown]').on('open.zf.drilldown hide.zf.drilldown closed.zf.drilldown',function(){
        $('#crumb').empty();
        $('.is-drilldown-submenu-parent[aria-expanded=true]').each(function(){
            var crumb = $(this).find('> a').text();
            $('#crumb').append('<i class="fas fa-caret-right breaker"></i> <span class="mobile-breadcrumb-link">' + crumb + "</span>");
        });
    });

    $('.mobile-breadcrumb-link').click(function(){
        $('.is-drilldown-submenu-parent[aria-expanded=true]').find('.new-back').trigger( "click" );
    })

    $('.lightbox').magnificPopup({type:'image'});

});

$(document).foundation();
